import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronDown14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.19965 6.67034L4.26031 5.60968L6.72998 8.07935L9.19965 5.60968L10.2603 6.67034L6.72998 10.2007L3.19965 6.67034Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronDown14.displayName = 'ChevronDown14';
export default ChevronDown14;
